const initialState = {
    isEnableLoader: false,
    isSessionTimedOut: false
};

const loaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case "TOGGLE_LOADER":
            return {
                ...state,
                isEnableLoader: !state.isEnableLoader
            }
        case 'TURN_OFF_LOADER':
            return {
                ...state,
                isEnableLoader: false
            }
        case "SESSION_TIMED_OUT":
            return {
                ...state,
                isSessionTimedOut: true
            }
        case "RESET_SESSION_TIMEOUT":
            return {
                ...state,
                isSessionTimedOut: false
            }
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

export default loaderReducer;
